import { createSelector } from 'reselect'
import interactiveVideoSettingsSaveSelector from 'redux/selectors/interactive_videos/interactive_video_settings_save_selector'

const pmSelector = state => state.interactiveVideo.pm

export default createSelector(
	[pmSelector, interactiveVideoSettingsSaveSelector],
	(pm, interactiveVideoSettings) => {
		const shouldHideStudentNames = pm === '-1'
			? interactiveVideoSettings.shouldHideStudentNames
			: pm === '1'
		const settings = {
			isInteractiveMode: interactiveVideoSettings.isInteractiveMode,
			shouldHideStudentNames,
		}
		return settings
	}
)
